var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',{on:{"click":function($event){$event.stopPropagation();return _vm.onRefresh.apply(null, arguments)}}},[_c('a-icon',{attrs:{"type":"reload"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }